import React, { useEffect, useState, useRef, useContext, useCallback } from 'react'
import styled from 'styled-components'
import CustomDropdown from '../../CustomDropdown/CustomDropdown'
import InputSearch from '../../InputSearch/InputSearch'
import VehicleList from '../../VehicleList'
import { useSortVehicle } from '../../../hooks/useSortVehicle'
import { useReverseGeocode } from '../../../hooks/useReverseGeocode'
import TripsContext from '../../../contexts/TripsContext'
import { useSearchVehicle } from '../../../hooks/useSearchVehicles'

import { usePaginate } from '../../../hooks/usePaginate'
import FilterDropdownLookup from '../../FiltersDropdownLookup'
import i18n from 'live/services/i18n'

type IProps = {
    data: any[]
    show?: boolean
    filters?: any[]
    applyFilters?(filter): void
    isLoading: boolean
}

const Vehicles = ({ data, filters = [], isLoading, applyFilters }: IProps): JSX.Element => {
    const { hardwareData = {}, isNavegateToTrips, selectedVehicles, markerHashMap , setVehicleActive, setInfoWindow } = useContext(TripsContext)
    const [open, setOpen] = useState(false)
    const topRef: any = useRef(null)
    const [options, optionSelected, sortVehicles] = useSortVehicle(topRef)
    const { loadingReverseGeocoding, fillGoogleReverseGeocodeAux } = useReverseGeocode()
    const { search } = useSearchVehicle()

    const [vehiclesLocal, setVehiclesLocal] = useState<any[]>([])
    const { numPage, sizePage, paginate } = usePaginate(data)
    const [option, setOption] = useState<any>(optionSelected)

    useEffect(() => {
        if(isLoading === false){
            loadVehiclesLocal(data, numPage, option)
        }
    }, [isLoading, data])

    const handleSort = (vehicles, option) => {
        loadVehiclesLocal(vehicles, numPage, option)
        setOption(option)
    }

    const loadVehiclesLocal = (vehicles, numPage = 1, option) => {        
        const aux = [...vehicles]

        let vLocal = []

        vLocal = sortVehicles(aux, option)
        // vLocal = paginate(vLocal, numPage)

        setVehiclesLocal(vLocal)
        fillGoogleReverseGeocodeAux(vLocal, hardwareData)
    }

    const loadMore = () => {
        loadVehiclesLocal(data, numPage + 1, option)
    }

    const LoadMore = ({ numPage, sizePage, total }: any): JSX.Element => {
        if (total === 0 || numPage * sizePage >= total) return <></>

        return (
            <div style={{ padding: 10 }}>
                <button className="btn-show-more" onClick={loadMore}>
                    {i18n('Load More')}
                </button>
            </div>
        )
    }

    const EmptyMessage = ({ total }: any) => {
        if (total > 0) return <></>

        return (
            <div className="no-content">
                <div>
                    <i className="fas fa-empty-set"></i>
                </div>
                <span className="no-content-first">{i18n('There are no results for your search.')}</span>
                <span className="no-content-second">{i18n('Redo your search to view the information.')}</span>
            </div>
        )
    }

    return (
        <>
            {isNavegateToTrips === undefined && (
                <StyledVehicles>
                    {(isLoading) && <div className="loading" />}

                    {isLoading === false && (
                        <>
                            <StyledContainerSearch>
                                <li className="flex-1">
                                    <InputSearch onSearch={search} placeholder="Buscar" />
                                </li>

                                {filters.length > 0 && (
                                    <li>
                                        <FilterDropdownLookup filters={filters} applyCallback={applyFilters} />
                                    </li>
                                )}

                                <li>
                                    <CustomDropdown
                                        options={options}
                                        open={open}
                                        selected={optionSelected}
                                        clickItem={(option: any) => handleSort(data, option)}
                                        clickOutside={() => setOpen(false)}
                                    >
                                        <button className="btn-action btn-blue" onClick={() => setOpen(!open)}>
                                            <i className="fas fa-sort-alt "></i>
                                        </button>
                                    </CustomDropdown>
                                </li>
                                <li>
                                    <button
                                        title="Reload last address position"
                                        className="btn-action btn-purple"
                                        onClick={() => fillGoogleReverseGeocodeAux(vehiclesLocal, hardwareData)}
                                    >
                                        {!loadingReverseGeocoding && <i className="fas fa-sync-alt"></i>}
                                        {loadingReverseGeocoding && <i className="fas fa-spinner fa-pulse"></i>}
                                    </button>
                                </li>
                            </StyledContainerSearch>

                            <StyleContainerList ref={topRef} noData={data.length === 0} hasItems={numPage * sizePage < data.length}>
                                {data.length > 0 && <VehicleList vehicles={vehiclesLocal} />}

                                <EmptyMessage total={data?.length} />
                            </StyleContainerList>

                            {/*<LoadMore numPage={numPage} sizePage={sizePage} total={data?.length} />*/}
                        </>
                    )}
                </StyledVehicles>
            )}
        </>
    )
}

export default React.memo(Vehicles)

const StyledVehicles = styled.div`
    background: ${({ theme }) => theme['gray-0']};
    height: 100%;
    //padding-bottom: 16px;
`

const StyledContainerSearch = styled.ul`
    display: flex;
    padding: 24px 24px 0 24px;
    position: relative;
    z-index: 100;
    background: #fff;

    .dropdown-menu {
        margin-top:52px !important;
    }
`

const StyleContainerList = styled.div`
    display: flex;
    overflow-y: scroll;
    padding: 16px;
    padding-bottom: 0;
    height: ${({ hasItems, noData }) => (noData ? `calc(100% - 70px)` : `calc(100% - ${hasItems ? 80 : 55}px)`)};

    align-items: ${({ noData }) => (noData ? `center` : 'initial')};
    justify-content: ${({ noData }) => (noData ? `center` : 'initial')};
    margin: ${({ noData }) => (noData ? `0 16px 16px 16px` : '0')};
    border: ${({ theme, noData }) => (noData ? `1px solid ${theme['gray-500']}` : 'none')};

    .no-content {
        text-align: center;
        padding: 0 15%;
        font-size: 13px;
        font-weight: 400;

        .no-content-first {
            font-weight: 600;
            color: ${({ theme }) => theme['gray-700']};
        }
    }

    .fa-empty-set {
        font-weight: 400;
        font-size: 40px;
        color: ${({ theme }) => theme['gray-600']};
    }

    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme['gray-500']};
        border-radius: 10px;
    }
`
